import { render, staticRenderFns } from "./PageParametersIndex.vue?vue&type=template&id=2b8d5c9a"
import script from "./PageParametersIndex.vue?vue&type=script&lang=js"
export * from "./PageParametersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8d5c9a')) {
      api.createRecord('2b8d5c9a', component.options)
    } else {
      api.reload('2b8d5c9a', component.options)
    }
    module.hot.accept("./PageParametersIndex.vue?vue&type=template&id=2b8d5c9a", function () {
      api.rerender('2b8d5c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pageParameters/PageParametersIndex.vue"
export default component.exports